import React from 'react';
import { FormTitleWrapper } from './styled';

const FormTitle = ({ title, styles }) => {
  return <FormTitleWrapper style={styles}>{title}</FormTitleWrapper>;
};

export default FormTitle;
